import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { SelectingType } from "./zonesSlice";

export type Type = "personal" | "linear" | "taxi_company" | "online_taxi";

interface IState {
  visible: boolean;
  trafficShowType: number;
  pointwiseShow: boolean;
  loading: boolean;
  trafficTypes: any[];
}

const initialState: IState = {
  visible: false,
  trafficShowType: 0,
  pointwiseShow: false,
  loading: false,
  trafficTypes: [],
};

export const trafficSlice = createSlice({
  name: "traffic",
  initialState,
  reducers: {
    changeTrafficShowType: (state, action: PayloadAction<number>) => {
      return { ...state, trafficShowType: action.payload };
    },
    toggleVisibility: (state) => {
      return { ...state, visible: !state.visible };
    },
    makeInvisible: (state) => {
      return { ...state, visible: false };
    },
    changeMarkerMode: (state, action: PayloadAction<SelectingType[]>) => {
      return { ...state, markerMode: action.payload };
    },
    togglePointwiseShow: (state) => {
      return { ...state, pointwiseShow: !state.pointwiseShow };
    },
    changeLoadingMode: (state, action: PayloadAction<boolean>) => {
      return { ...state, loading: action.payload };
    },
    // changeType: (state, action: PayloadAction<Type>) => {
    //   return { ...state, type: action.payload };
    // },
    changeTrafficType: (state, action: PayloadAction<any>) => {
      if (state.trafficTypes.includes(action.payload)) {
        return { ...state, trafficTypes: state.trafficTypes.filter((c) => c !== action.payload) };
      }
      return { ...state, trafficTypes: [...state.trafficTypes, action.payload] };
    },
  },
});

export const {
  changeTrafficShowType,
  toggleVisibility,
  makeInvisible,
  togglePointwiseShow,
  changeLoadingMode,
  changeTrafficType,
} = trafficSlice.actions;

export default trafficSlice.reducer;
